import PaymentCompleted from '@/components/payments/PaymentCompleted.vue'
import PaymentFailed from '@/components/payments/PaymentFailed.vue'
import PaymentPage from '@/components/payments/PaymentPage.vue'

export default [
  { path: '/placilo/:id/uspesno', component: PaymentCompleted, name: 'finalized_document_paid_path', meta: { title: 'Plačilo uspešno', isLoginRequired: true }, props: true },
  { path: '/placilo/:id/zavrnjeno', component: PaymentFailed, name: 'finalized_document_payment_failed_path', meta: { title: 'Plačilo zavrnjeno', isLoginRequired: true }, props: true },
  { path: '/placilo/:id', component: PaymentPage, name: 'finalized_document_payment', meta: { title: 'Plačilo' }, props: true },
]
